import { Flowstep } from "@shared/types/flowstep";
import { WorkbookApi } from "@shared/execution/workbook-api";

export const replaceTimestampValue = async  (flowstep: Flowstep, workbookApi: WorkbookApi<any>) => {
  if (!flowstep.options.timestampCell?.customRange) {
    return;
  }
  const range = await workbookApi.getRangeByAddress(flowstep.options.timestampCell.customRange);
  if (!range) {
    //We don't need to stop flowstep if only timestamp cell is not found
    return;
  }
  const rangeAddressInfo = await workbookApi.getRangeAddressInfo(range);
  flowstep.options.timestampCell = {
    worksheetId: rangeAddressInfo.worksheetId,
    address: rangeAddressInfo.address,
  };
}
